module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAm0lEQVR4AWOgC/h/5EhU9d6jFx7/Tww8cuG5Y9pmoMj/BwyYCAqAqoEqzl/e/X+7FFADkA3Ug0/D/39f//68d+D4FQunjH3Hb/z/+/4/EODTkOX9/yLnztiQnWsUdyUE/T8uAHQbPg0gB5xYferS+b/bpY5dfPB/7Yze/r14bZg+3a9wx5ELT//HBwH9UN21n4CnscoNWw2DEwAAULgoxJusMfEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NU.png
// module id = 1233
// module chunks = 0